import { render, staticRenderFns } from "./MonitorPointViewer.vue?vue&type=template&id=3862a8b2"
import script from "./MonitorPointViewer.vue?vue&type=script&lang=js"
export * from "./MonitorPointViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports